<template>
    <div class="table-wrapper" style="padding-top: 20px;">
        <Form ref="formInline" :model="formInline" inline
            :label-width="100" label-position="right">
            <div class="search-right-wrapper">
                <Button :loading="eLoading" type="primary" style="float:left;" icon="ios-exit-outline" @click="handleExport">导出</Button>
                <FormItem class="form-calc"  label="项目所在地:" style="width:286px;text-align:left;">
                    <!--<place-select v-model="areaCode"></place-select>-->
                    <Cascader v-model="areaCode" :data="counties" clearable placeholder="请选择地区" change-on-select></Cascader>
                </FormItem>
                <Button style="margin-left: 20px;float:right;" @click="handleReset">重置</Button>
                <Button style="float: right;" type="primary" @click="handleQuery">搜索</Button>
            </div>
        </Form>
        <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
            <template slot-scope="{ row, index }" slot="action">
                <span class="pointer" type="text" size="small" @click="handleDeal('postWarningDetail', row)" v-if="row.areaName !== '合计'">详情</span>
            </template>
        </Table>
        <!-- <div class="t-page">
            <Page :total="totalCount" :page-size="pageSize" :current="page"
                @on-change="changePage" @on-page-size-change="pageSizeChange"
                show-elevator show-sizer show-total transfer>
            </Page>
        </div> -->
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                counties: [],
                areaCode: [],
                eLoading: false,
                formInline:{
                    startDate:'',
                    endDate:''
                },
                formOutLine1: {
                    startDate:'',
                    endDate:''
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '地区',
                        key: 'areaName',
                        minWidth:100,
                    },
                    {
                        title: '在建项目数',
                        key: 'buildingCount',
                        minWidth:150,
                        sortable: true,
                        align: 'right'
                    },
                    {
                        title: '施工总承包单位的项目经理岗位预警',
                        align: 'center',
                        children: [
                            {
                                title:'未设置项目经理的项目数',
                                key: 'unSetManagerProjectCount',
                                minWidth: 150,
                                sortable: true,
                                align: 'right'
                            },
                            {
                                title:'已设置项目经理的项目数',
                                key: 'yetSetManagerProjectCount',
                                minWidth: 150,
                                sortable: true,
                                align: 'right'
                            },
                        ]

                    },
                    {
                        title: '监理单位的总监理工程师岗位预警',
                        align: 'center',
                        children: [
                            {
                                title:'未设置总监理工程师的项目数',
                                key: 'unSetSupervisorProjectCount',
                                minWidth: 170,
                                sortable: true,
                                align: 'right'
                            },
                            {
                                title:'已设置总监理工程师的项目数',
                                key: 'yetSetSupervisorProjectCount',
                                minWidth: 170,
                                sortable: true,
                                align: 'right'
                            },
                        ]

                    },
                    {
                        title: '操作',
                        slot: 'action',
                        fixed: 'right',
                        align: 'center',
                        width: 100
                    }
                ],
                tableData:[],
                exportData:{
                    size:this.pageSize,
                    current:this.page,
                    areaCode: '',
                }
            };
        },
        computed:{
            ...mapState(['area']),
        },
        created(){

        },
        mounted(){
            this.init()

        },
        watch: {

        },
        methods: {
            init() {
                this.$nextTick(()=>{
                    this.areaCode = []
                    if(JSON.stringify(this.$route.query) != '{}') {
                        let code = this.$route.query.areaCode
                        this.areaCode.push(this.$route.query.areaCode.substring(0, 2) + '0000')
                        if (code.substring(2, 4) != '00') {
                            this.areaCode.push(this.$route.query.areaCode.substring(0, 4) + '00')
                        }
                        if (code.substring(4, 6) != '00') {
                            this.areaCode.push(this.$route.query.areaCode)
                        }
                    } else {
                        this.areaCode.push(this.common.getTenantAreaCode())
                    }
                    this.getCounties()
                    this.getTableData();
                })
            },
            // 项目详细地址
            getCounties() {
                this.axios({
                    method: 'get',
                    url:`/dict/counties?areaCode=${this.common.getTenantAreaCode()}`,
                }).then( (res)=> {
                    this.counties = res.data.data
                })
            },
            timeChange(val) {
                this.formInline.startDate = val[0]
                this.formInline.endDate = val[1]
            },
            //导出
            handleExport(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    // size:this.pageSize,
                    // current:this.page,
                    areaCode: this.areaCode[this.areaCode.length-1],
                };
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/keyPosition/export',
                    responseType:'arraybuffer',
                    data: param
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response, '关键岗位预警.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name, row){
                let routeName = '';
                if(row.haveChildArea){
                    routeName = 'postWarningDetail'
                }else{
                    routeName = 'postWarningDetailProject'
                }
                this.$router.push({
                    name: routeName,
                    query: {
                        areaCode: row.areaCode
                    }
                });
            },
            handleReset() {
                this.areaCode = []
                this.areaCode.push(this.common.getTenantAreaCode());
                this.page = 1
                this.formInline = {
                    startDate:'',
                    endDate:''
                }
                this.getTableData()
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    // size:this.pageSize,
                    // current:this.page,
                    areaCode: this.areaCode[this.areaCode.length-1],
                };
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/keyPosition/statisticsList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        // this.totalCount = response.data.data.total
                        this.tableData=response.data.data
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped >
.form-calc>>>.ivu-cascader .ivu-cascader-menu-item{
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
}
    .dataTab .ivu-tabs-bar {
        margin-bottom: 0;
        border-bottom: none;
    }
</style>
